import * as React from 'react';
import styled from 'styled-components';
import random from 'lodash/random';
import compact from 'lodash/compact';
import last from 'lodash/last';

import { Text, Spinner } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

interface ILoadingTextProps {
  text: string;
  onLoaded: () => any;
}

interface ILoadingTextState {
  text: string;
  i: number;
}

const StyledText = styled(Text)`
  line-height: 2;
`;

export class LoadingText extends React.Component<ILoadingTextProps, ILoadingTextState> {
  state = {
    i: 0,
    text: '',
  };

  componentDidMount() {
    this.updateText();
  }

  updateText() {
    const { text } = this.props;
    const { i } = this.state;

    if (i < text.length) {
      setTimeout(() => {
        this.setState(
          {
            text: text.substring(0, i),
            i: i + 1,
          },
          this.updateText,
        );
      }, random(15, 30));
    } else {
      this.props.onLoaded();
    }
  }

  render() {
    const { text } = this.state;
    return (
      <div>
        <Box marginBottom={2} display="flex" justifyContent="center">
          <Spinner size="md" />
        </Box>
        <StyledText size="md" align="center" color="grey80">
          {text.split('').map((ch) => (ch === '\n' ? <br /> : ch))}
        </StyledText>
      </div>
    );
  }
}
